import { StatsAttributionFactory } from '../../module/stats/attribution.factory';
import { StatsAttribution } from '../../module/stats/attribution';

const statsAttributionService = StatsAttributionFactory();

export function StatsAttributionService(): StatsAttribution {
  return statsAttributionService;
}
